/* eslint-disable jsx-a11y/anchor-is-valid */
import type { RootState } from '@/store/store';
import type { FC } from 'react';

import { setBrandGroupIdle } from '@/store/organization/brandGroupSlice';
import { setCategoryGroupIdle } from '@/store/organization/categoryGroupSlice';
import { setClientIdle } from '@/store/organization/clientSlice';
import { setKeywordGroupIdle } from '@/store/organization/keywordGroupSlice';
import { setOrganizationsIdle } from '@/store/organization/organizationSlice';
import { toggleTheme } from '@/store/theme/themeSlice';
import { Avatar, DarkThemeToggle, Dropdown, Navbar } from 'flowbite-react';
import { HiMenuAlt1, HiSearch, HiX } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useSidebarContext } from '../context/SidebarContext';
import isSmallScreen from '../helpers/is-small-screen';
import { logout } from '../store/auth/authSlice';
import { useAppDispatch } from '../store/hooks';

type ILogoutProps = { handleLogout: () => void };

const ExampleNavbar: FC = function () {
  const { isOpenOnSmallScreens, isPageWithSidebar, setOpenOnSmallScreens } =
    useSidebarContext();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout()).then(() => {
      dispatch(setClientIdle());
      dispatch(setOrganizationsIdle());
      dispatch(setKeywordGroupIdle());
      dispatch(setBrandGroupIdle());
      dispatch(setCategoryGroupIdle());
      navigate('/authentication/sign-in');
    });
  };

  return (
    <Navbar fluid>
      <div className="z-50 w-full p-3 lg:px-5 lg:pl-3">
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center">
            {isPageWithSidebar && (
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="mr-3 cursor-pointer rounded p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white lg:inline"
              >
                <span className="sr-only">Toggle sidebar</span>
                {isOpenOnSmallScreens && isSmallScreen() ? (
                  <HiX className="h-6 w-6" />
                ) : (
                  <HiMenuAlt1 className="h-6 w-6" />
                )}
              </button>
            )}
            <Navbar.Brand href="/">
              <img
                alt=""
                src="https://flowbite.com/docs/images/logo.svg"
                className="mr-3 h-6 sm:h-8"
              />
              <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white">
                mpSerpent
              </span>
            </Navbar.Brand>
            {/* <form className="ml-16 hidden md:block">
              <Label htmlFor="search" className="sr-only">
                Search
              </Label>
              <TextInput
                icon={HiSearch}
                id="search"
                name="search"
                placeholder="Search"
                required
                size={32}
                type="search"
              />
            </form> */}
          </div>
          <div className="flex items-center lg:gap-3">
            <div className="flex items-center">
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="cursor-pointer rounded p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:bg-gray-700 dark:focus:ring-gray-700 lg:hidden"
              >
                <span className="sr-only">Search</span>
                <HiSearch className="h-6 w-6" />
              </button>
              {/* <NotificationBellDropdown />
              <AppDrawerDropdown handleLogout={handleLogout} /> */}
              <DarkThemeToggle onPointerUp={() => dispatch(toggleTheme())} />
            </div>
            <div className="hidden lg:block">
              <UserDropdown handleLogout={handleLogout} />
            </div>
          </div>
        </div>
      </div>
    </Navbar>
  );
};

const UserDropdown: FC<ILogoutProps> = function ({ handleLogout }) {
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <Dropdown
      arrowIcon={false}
      inline
      label={
        <span>
          <span className="sr-only">User menu</span>
          <Avatar
            alt=""
            img="../images/users/neil-sims.png"
            rounded
            size="sm"
          />
        </span>
      }
    >
      <Dropdown.Header>
        {/* <span className="block text-sm">
          {user?.first_name} {user?.last_name} @{user?.username}
        </span> */}
        <span className="block truncate text-sm font-medium">
          {user?.email}
        </span>
      </Dropdown.Header>
      <Dropdown.Item>Dashboard</Dropdown.Item>
      <Dropdown.Item>Settings</Dropdown.Item>
      <Dropdown.Item>Earnings</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={handleLogout}>Sign out</Dropdown.Item>
    </Dropdown>
  );
};

export default ExampleNavbar;
